<ng-container *transloco="let t">
  <app-page-template [showFooter]="!isPreviewComponent">
    <div class="container pb-300-100">
      <div>
        <div class="container container-no-padding-sm">
          <app-page-header-public [currentRace]="race" [currentItem]="eventItem"/>
          <app-info-section-public [currentItem]="eventItem" [languages]="languages"
                                   [currentItemType]="CurrentItemType.EVENT">
            <ng-container slot="title-slot">
              <h1 class="info-area__title flex-grow-1 trim-text-second-line pe-2">
                <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng"
                                     [itLabel]="race?.nameIta"
                                     [siLabel]="race?.nameSlo"
                                     [srLabel]="race?.nameSr"
                                     [bsLabel]="race?.nameBs"
                                     [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages"/>
              </h1>
            </ng-container>
          </app-info-section-public>
          <div class="horizontal-separator">
          </div>
        </div>
        <div class="nav-bar-padding">
          @if (race ?? false) {
            <app-nav-tabs tabCssClass="container container-no-padding-sm">
              <app-nav-tab [title]="t('app.common.description')" [itemId]="1">
                <ng-template>
                  <div class="container container-no-padding-sm">
                    <div class="pt-62-32 pb-300-100">
                      <span class="desc-title">{{ t("race.details.about") }}</span>
                      <div class="vertical-separator"></div>
                      <div class="desc-text pb-48-36">
                        <app-language-output [hrLabel]="race?.shortDescription" [srLabel]="race?.shortDescriptionSr"
                                             [enLabel]="race?.shortDescriptionEng"
                                             [bsLabel]="race?.shortDescriptionBs"
                                             [itLabel]="race?.shortDescriptionIta" [siLabel]="race?.shortDescriptionSlo"
                                             [defaultLanguage]="eventItem?.defaultLanguage" [showAsInnerHtml]="true"
                                             [defaultLabel]="t('race.details.empty')" [languages]="languages"/>
                      </div>
                      <div class="race-details">
                        <div class="race-details__item">
                          <div class="race-details__content">
                            <div class="fw-semibold">{{ t("event.item.start.date") }}</div>
                            <div> {{
                                race
                                  ? (race.raceStart | localizedDate:'shortDate')
                                  : '-'
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="race-details__item">
                          <div class="race-details__content">
                            <div class="fw-semibold"> {{ t("event.item.start.time") }}</div>
                            <div> {{
                                race
                                  ? (race.raceStart | localizedDate:'shortTime')
                                  : '-'
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="race-details__item">
                          <div class="race-details__content">
                            <div class="fw-semibold"> {{ t("event.item.time.limit") }}</div>
                            <div>{{ race?.raceStart|timeLimit:race?.raceEnd }}
                            </div>
                          </div>
                        </div>
                        <div class="race-details__item">
                          <div class="race-details__content">
                            <div class="fw-semibold">{{ t("race.details.start.location") }}</div>
                            <div> {{ startWaypoint | waypointLocation:countries }}
                            </div>
                          </div>
                        </div>
                        <div class="race-details__item">
                          <div class="race-details__content">
                            <div class="fw-semibold">{{ t("race.details.end.location") }}</div>
                            <div> {{ finishWaypoint | waypointLocation:countries }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="pt-48-38">
                        <div class="details-wrapper">
                          <div class="race-more-details px-4">
                            <div class="race-more-details__item fs-18">
                              <div class="race-more-details__icon-wrapper">
                                <img src="assets/icons/location-icon-alt.svg"
                                     [alt]="t('app.map.elevation.graph.distance.m')"/>
                              </div>
                              <div class="race-more-details__item-text">
                                <div class="fw-bold">
                                  {{ t("app.map.elevation.graph.distance.m") }}
                                </div>
                                <div>
                                  {{ race?.length | raceLengthFormat:translocoService.getActiveLang() }}
                                </div>
                              </div>
                            </div>
                            <div class="race-more-details__item fs-18">
                              <div class="race-more-details__icon-wrapper">
                                <img src="assets/img/svg/elevation.svg" [alt]="t('app.map.elevation.graph.elevation')"/>
                              </div>
                              <div class="race-more-details__item-text">
                                <div class="fw-bold">
                                  {{ t("app.map.elevation.graph.elevation") }}
                                </div>
                                <div>
                                  {{ race | raceAscentDescentFormat }}
                                </div>
                              </div>
                            </div>
                            <div class="race-more-details__item fs-18">
                              <div class="race-more-details__icon-wrapper">
                                <img src="assets/img/svg/control-point.svg" [alt]="t('race.details.controlPoints')"/>
                              </div>
                              <div class="race-more-details__item-text">
                                <div class="fw-bold">
                                  {{ t("race.details.controlPoints") }}
                                </div>
                                <div>
                                  {{ race?.checkpointAmount ?? "-" }}
                                </div>
                              </div>
                            </div>
                            <div class="race-more-details__item fs-18">
                              <div class="race-more-details__icon-wrapper">
                                <img src="assets/img/svg/feed-zone.svg" [alt]="t('race.details.feedZones')"/>
                              </div>
                              <div class="race-more-details__item-text">
                                <div class="fw-bold">
                                  {{ t("race.details.feedZones") }}
                                </div>
                                <div>
                                  {{ race?.refreshmentCheckpointAmount ?? "-" }}
                                </div>
                              </div>
                            </div>
                            <div class="race-more-details__item fs-18">
                              <div class="race-more-details__icon-wrapper">
                                <img src="assets/img/svg/max-alt.svg" [alt]="t('race.details.max.altitude.short')"/>
                              </div>
                              <div class="race-more-details__item-text">
                                <div class="fw-bold">
                                  {{ t("race.details.max.altitude.short") }}
                                </div>
                                <div>
                                  {{ race?.maxAltitude ? race?.maxAltitude + "m" : "-" }}
                                </div>
                              </div>
                            </div>
                            <div class="race-more-details__item fs-18">
                              <div class="race-more-details__icon-wrapper">
                                <img src="assets/img/svg/min-alt.svg" [alt]="t('race.details.min.altitude.short')"/>
                              </div>
                              <div class="race-more-details__item-text">
                                <div class="fw-bold">
                                  {{ t("race.details.min.altitude.short") }}
                                </div>
                                <div>
                                  {{ race?.minAltitude ? race?.minAltitude + "m" : "-" }}
                                </div>
                              </div>
                            </div>
                            <div class="race-more-details__item fs-18">
                              <div class="race-more-details__icon-wrapper">
                                <img src="assets/img/svg/max-participants.svg"
                                     [alt]="t('race.details.max.participants')"/>
                              </div>
                              <div class="race-more-details__item-text">
                                <div class="fw-bold">
                                  {{ t("race.details.max.participants") }}
                                </div>
                                <div>
                                  {{ race?.maxParticipants ?? "-" }}
                                </div>
                              </div>
                            </div>
                            <div class="race-more-details__item fs-18">
                              <div class="race-more-details__icon-wrapper">
                                <img src="assets/img/svg/registered-participants.svg"
                                     [alt]="t('race.details.reg.participants')"/>
                              </div>
                              <div class="race-more-details__item-text">
                                <div class="fw-bold">
                                  {{ t("race.details.reg.participants") }}
                                </div>
                                <div>
                                  {{ race?.competitorCount?.total ?? "-" }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="pt-48-38">
                        @if (race?.raceScoring?.scoringDefinition) {
                          <span class="desc-title">{{ t("race.details.racing.points") }}</span>
                          <div class="vertical-separator"></div>
                          <div class="row">
                            <div class="col-12">
                              @if (race!.raceScoring!.scoringFor === ScoringForType.ITRA) {
                                <app-horizontal-box-list>
                                  <app-horizontal-box-list-item>
                                  <span class="title-content fw-semibold">
                                  {{ t("race.details.itraPoints") }}
                                  </span>
                                    <span class="content">{{ race?.raceScoring?.itraPoints ?? "-" }}</span>
                                  </app-horizontal-box-list-item>
                                  <app-horizontal-box-list-item>
                                  <span class="title-content fw-semibold">
                                     {{ t("race.details.mountainLevel") }}
                                    </span>
                                    <span class="content">{{ race?.raceScoring?.mountainLevel ?? "-" }}</span>
                                  </app-horizontal-box-list-item>
                                  <app-horizontal-box-list-item>
                            <span class="title-content fw-semibold">
                                    {{ t("race.details.utmbQualifier") }}
                             </span>
                                    <span class="content">{{ race?.raceScoring?.utmbQualifier ?? "-" }}</span>
                                  </app-horizontal-box-list-item>
                                  <app-horizontal-box-list-item>
                      <span class="title-content fw-semibold">
                          {{ t("race.details.finisherLevel") }}
                                </span>
                                    <span class="content">{{ race?.raceScoring?.finisherLevel ?? "-" }}</span>
                                  </app-horizontal-box-list-item>
                                </app-horizontal-box-list>
                              } @else if (race?.raceScoring?.scoringFor === ScoringForType.CONFIGURE
                              && race?.raceScoring?.nameOne && race?.raceScoring?.valueOne) {
                                <app-horizontal-box-list>
                                  <app-horizontal-box-list-item>
                      <span class="title-content fw-semibold">
                          {{ race!.raceScoring!.nameOne }}
                                </span>
                                    <span class="content">{{ race!.raceScoring!.valueOne }}</span>
                                  </app-horizontal-box-list-item>
                                </app-horizontal-box-list>
                              }
                            </div>
                          </div>
                        }
                        @if (raceCommercialItems && raceCommercialItems.length > 0) {
                          <div class="row">
                            <div class="col-12">
                              <div class="pt-40 pb-24">
                                <app-header-alt [title]="t('race.details.pricing')" [isSemiBold]="true"/>
                              </div>
                            </div>
                            @for (item of raceCommercialItems;track item) {
                              <app-race-pricing-table [raceCommercialItem]="item" [event]="eventItem" [race]="race"
                                                      [languages]="languages"></app-race-pricing-table>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-nav-tab>
              <app-nav-tab [title]="t('race.grid.map')" [itemId]="2">
                <ng-template>
                  <app-race-map-tab [languages]="languages" [eventItem]="eventItem" [race]="race"
                                    [waypointList]="waypointList" [raceRoute]="raceRoute">
                  </app-race-map-tab>
                </ng-template>
              </app-nav-tab>
              @if (competitors.length > 0) {
                <app-nav-tab [title]="t('race.details.competitors')" [itemId]="3">
                  <ng-template>
                    <div class="content-box mt-16">
                      <app-competitor-table [competitors]="competitors" [race]="race" [languages]="languages"
                                            [countries]="countries"
                                            [applicationFormSettings]="race?.applicationFormSettings"
                                            [genders]="genders" [showLoadMoreButton]="true"/>
                    </div>
                  </ng-template>
                </app-nav-tab>
              }
              @if (results.length > 0) {
                <app-nav-tab [title]="t('race.grid.results')" [itemId]="4">
                  <ng-template>
                    <div class="content-box mt-16">
                      <app-results-table [results]="results" [languages]="languages" [categories]="categories"
                                         [genders]="genders"
                                         [event]="eventItem" [race]="race"/>
                    </div>
                  </ng-template>
                </app-nav-tab>
              }
              <div class="d-flex flex-nowrap align-items-center">
                <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'"
                                [text]="t('race.grid.register')" [borderColor]="'var(--teal-500)'"
                                (onClickCallback)="onRegister()" [isDisabled]="!race?.open"></app-button-alt>
              </div>
            </app-nav-tabs>
          } @else {
            <app-empty-state/>
          }
        </div>
      </div>
    </div>
  </app-page-template>
</ng-container>
